import { ChevronDown, SlidersHorizontal } from 'lucide-react';
import { Badge } from '@/components/reui/badge';
import { Button } from '@/components/ui/button';
import type { BotonFiltrosProps } from './tipos';

// Trigger del popover «Filtros» (pieza compartida, Ajuste #16 y #28; plan de
// migración a ReUI §3 R2, c-button-45: Button variant="outline" + Badge
// inline). `Button` ya reacciona a `aria-expanded` (fondo `muted`) cuando el
// popover está abierto, así que no hace falta pintar un estado «abierto» a
// mano. `FiltrosPopover` lo usa como `render` de `PopoverTrigger`, que le suma
// `aria-expanded`, `data-popup-open` y el onClick. Nada del dominio adentro:
// el número del badge lo cuenta la página.

const fmt = new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 });

export function BotonFiltros({ nActivos, etiqueta = 'Filtros', className, type = 'button', ...props }: BotonFiltrosProps) {
  const hayActivos = nActivos > 0;
  const ariaLabel = hayActivos
    ? `${etiqueta}, ${fmt.format(nActivos)} ${nActivos === 1 ? 'activo' : 'activos'}`
    : etiqueta;

  return (
    <Button
      type={type}
      variant="outline"
      aria-haspopup="dialog"
      aria-label={ariaLabel}
      {...props}
      className={className}
    >
      <SlidersHorizontal aria-hidden="true" data-icon="inline-start" strokeWidth={1.8} />
      {etiqueta}
      {hayActivos && (
        // El número lo lee el aria-label del botón; el badge es solo visual.
        // size="default" a propósito (desvío de c-button-45, que usa "sm"): el
        // "sm" del Badge mide 10 px, bajo el mínimo de 11 px de la app — mismo
        // motivo del Ajuste 15 para «actual»/«Migrada».
        <Badge aria-hidden="true" variant="primary-light" size="default" radius="full" className="text-salta">
          {fmt.format(nActivos)}
        </Badge>
      )}
      <ChevronDown aria-hidden="true" data-icon="inline-end" strokeWidth={1.8} />
    </Button>
  );
}
